setTimeout(function() {
  if (jQuery('[data-current-model]').length > 0 && jQuery('[data-model-list]').length > 0) {
    jQuery('[data-current-model]').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var closeModelSwitcher = jQuery(this).parent('[data-model-switcher]');
      jQuery('[data-model-list]', closeModelSwitcher).toggle();
      jQuery(this).toggleClass('active');
    });
    
    jQuery('[data-model-switch]').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var modelName = jQuery(this).attr('data-model');
      document.querySelector('media-gallery').modelName = modelName;
      jQuery('[data-current-model]').text(modelName);
      jQuery('[data-model-switch]').removeClass('active');
      jQuery(`[data-model-switch][data-model="${modelName}"]`).addClass('active');

      jQuery('[data-model-list]').hide();
      jQuery('[data-current-model]').removeClass('active');

      if (jQuery('.product-media-collage').length > 0) {
        jQuery('.product-media-collage .product-media-collage__item').removeClass('show-model-switcher');
        document.querySelectorAll('.product-media-collage .product-media-collage__item').forEach(function(item) {
          if (item.querySelector('img')) {
            var img = item.querySelector('img');
            if (img.alt != '') {
              if (img.alt.toLowerCase().indexOf(modelName.toLowerCase()) !== -1) {
                item.style.display = 'block';
              } else {
                item.style.display = 'none';
              }
            }
          }
        });
        jQuery('.product-media-collage .product-media-collage__item:visible:first').addClass('show-model-switcher');
      } 

      if (document.querySelector('.gallery-viewer-modal .gallery-viewer__thumbs')) {
         document.querySelectorAll('.gallery-viewer-modal .gallery-viewer__thumbs .gallery-viewer__thumb').forEach(function(item) {
          if (item.querySelector('img')) {
            var img = item.querySelector('img');
            if (img.alt != '') {
              if (img.alt.toLowerCase().indexOf(modelName.toLowerCase()) !== -1) {
                item.style.display = 'inline-block';
              } else {
                item.style.display = 'none';
              }
            }
          }
        });
      }

      if (document.querySelector('media-gallery carousel-slider')){
        document.querySelectorAll('media-gallery carousel-slider .slider__item').forEach(function(item) {
          if (item.querySelector('img')) {
            var img = item.querySelector('img');
            if (img.alt != '') {
              if (img.alt.toLowerCase().indexOf(modelName.toLowerCase()) !== -1) {
                item.removeAttribute('hidden');
              } else {
                item.setAttribute('hidden','');
              }
            }
          }
        });
        document.querySelector('media-gallery carousel-slider').refresh();
        document.querySelector('media-gallery carousel-slider.thumbnails').refresh();
      }
    });
  }
  if (jQuery('.product-media-collage__item:first [data-model-list] li').length > 1) {
    jQuery('.product-media-collage__item:first [data-model-list] li:first').trigger('click');
  }
},500);